<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Filtragem de categorias"
    txt-botao="aplicar"
    @click:primary="() => aplicarFiltros()"
  >
    <template #ativador>
      <v-btn icon dark @click="dialog_ativo = true">
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </template>

    <div v-if="dialog_ativo">
      <SysCategoriasAutocomplete
        v-model="filtros.idcategoria_nivel1"
        label="Categorias de nível 1"
        v-bind="props_inputs_sys_categorias"
      />

      <SysCategoriasAutocomplete
        v-model="filtros.idcategoria_nivel2"
        label="Categorias de nível 2"
        v-bind="props_inputs_sys_categorias"
        :categorias_pai="filtros.idcategoria_nivel1"
        :disabled="! (filtros.idcategoria_nivel1 && filtros.idcategoria_nivel1.length > 0)"
      />

      <SysCategoriasAutocomplete
        v-model="filtros.idcategoria_nivel3"
        label="Categorias de nível 3"
        v-bind="props_inputs_sys_categorias"
        :categorias_pai="filtros.idcategoria_nivel2"
        :disabled="! (filtros.idcategoria_nivel2 && filtros.idcategoria_nivel2.length > 0)"
      />

      <SysCategoriasAutocomplete
        v-model="filtros.idcategoria_nivel4"
        label="Categorias de nível 4"
        v-bind="props_inputs_sys_categorias"
        :categorias_pai="filtros.idcategoria_nivel3"
        :disabled="! (filtros.idcategoria_nivel3 && filtros.idcategoria_nivel3.length > 0)"
      />

      <SysCategoriasAutocomplete
        v-model="filtros.idcategoria_nivel5"
        label="Categorias de nível 5"
        v-bind="props_inputs_sys_categorias"
        :categorias_pai="filtros.idcategoria_nivel4"
        :disabled="! (filtros.idcategoria_nivel4 && filtros.idcategoria_nivel4.length > 0)"
      />
    </div>
  </SysDialog>
</template>

<script>
import {ref} from "vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import SysCategoriasAutocomplete from "@/components/SysCategorias/SysCategoriasAutocomplete";

export default {
  name: "FiltrosSysCategorias",
  components: {
    SysDialog,
    SysCategoriasAutocomplete
  },
  setup(_, ctx) {
    let dialog_ativo = ref(false);

    const filtros = ref({
      idcategoria_nivel1: [],
      idcategoria_nivel2: [],
      idcategoria_nivel3: [],
      idcategoria_nivel4: [],
      idcategoria_nivel5: [],
    });

    const props_inputs_sys_categorias = {
      outlined: true,
      clearable: true,
      "hide-details": true,
      class: "mb-3",
      multiple: true,
      ocultar_cadastro: true,
    };

    const aplicarFiltros = (nivel = 5) => {
      if (!filtros.value.idcategoria_nivel1 || filtros.value.idcategoria_nivel1.length === 0) {
        onUpdateFiltros([]);
      }

      if (nivel <= 0 || !nivel || isNaN(nivel)) return;

      const filtros_nivel = filtros.value[`idcategoria_nivel${nivel}`];

      if (!filtros_nivel || filtros_nivel.length === 0) {
        aplicarFiltros(nivel - 1);
        return;
      }

      onUpdateFiltros(filtros_nivel);
    };

    const onUpdateFiltros = novos_filtros => {
      ctx.emit('update:filtros', novos_filtros);
      dialog_ativo.value = false;
    };

    return {
      dialog_ativo,
      filtros,
      props_inputs_sys_categorias,
      aplicarFiltros
    }
  }
}
</script>

<style scoped>

</style>
